import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Search(props) {
  const {
    placeholder,
    className,
    onChange
  } = props;

  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);

  const handleWrapperClick = () => {
    inputRef.current.focus();
  };

  const handleWrapperKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      inputRef.current.focus();
    }
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleClearInput = () => {
    setInputValue('');
    if (onChange) {
      onChange('');
    }
    inputRef.current.focus();
  };

  return (
    <div className={classNames('png__search_wrapper', className)}>
      <div
        className="search-body"
        role="button"
        tabIndex={0}
        onClick={handleWrapperClick}
        onKeyDown={handleWrapperKeyDown}
        aria-label="Focus on search input"
      >
        <div className="search-input-wrapper">
          <i className="ri-search-2-line search-icon-search" />
          <input
            ref={inputRef}
            className="search-input-tag"
            type="text"
            placeholder={placeholder}
            onChange={handleInputChange}
            value={inputValue}
          />
        </div>
        {inputValue && (
          <i
            className="ri-close-fill search-icon-close"
            role="button"
            tabIndex={0}
            onClick={handleClearInput}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                handleClearInput();
              }
            }}
            aria-label="Clear search input"
          />
        )}
      </div>
    </div>
  );
}

Search.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};

Search.defaultProps = {
  placeholder: 'Search',
  className: '',
  onChange: null
};

export default Search;
